import { render } from "./UploadRecordDetail.vue?vue&type=template&id=51753d56"
import script from "./UploadRecordDetail.vue?vue&type=script&lang=js"
export * from "./UploadRecordDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__